import { render, staticRenderFns } from "./IsRestrictedColumn.vue?vue&type=template&id=ddfb1c18"
import script from "./IsRestrictedColumn.vue?vue&type=script&lang=ts"
export * from "./IsRestrictedColumn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports